import { goRequest, goRequestWithRecaptcha } from '../utils/httpClient';

export const getDonationFunds = () =>
  goRequest({
    url: '/donation/funds',
    method: 'GET',
  });

export const getDonationProjects = () =>
  goRequest({
    url: '/donation/projects',
    method: 'GET',
  });

export const getBehalfOfTypes = () =>
  goRequest({
    url: '/donation/behalf_of_types',
    method: 'GET',
  });

export const createDonation = (data) =>
  goRequestWithRecaptcha('donation_from', {
    url: '/donation',
    method: 'POST',
    data: data,
  });

export const createDonationLines = (data) =>
  goRequestWithRecaptcha('donation_lines', {
    url: '/donation/lines',
    method: 'POST',
    data: data,
  });

export const getInProgressDonation = (data) =>
  goRequest({
    url: `/donation/inprogress/${data.id}`,
    method: 'GET',
  });

export const removeDonationLine = (data) =>
  goRequest({
    url: `/donation/lines/${data.id}`,
    method: 'DELETE',
  });

export const removeDonationNotification = (data) =>
  goRequest({
    url: `/donation/behalf_of/notification/${data.id}`,
    method: 'DELETE',
  });

export const getDonationList = (data) => {
  let url = `/donations/list?page_size=${data.rowsPerPage}&page=${data.page}`;
  if (data.search) {
    url += `&search=${data.search}`;
  }
  if (data.orderBy) {
    url += `&order_by=${data.orderBy}`;
  }
  if (data.order) {
    url += `&order=${data.order}`;
  }
  return goRequest({
    url: url,
    method: 'GET',
  });
};

export const getDonationDetail = (data) =>
  goRequest({
    url: `/donations/${data.id}`,
    method: 'GET',
  });

export const getDonationChapters = () =>
  goRequest({
    url: '/donations/chapters',
    method: 'GET',
  });
